module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/point_maedori_03@2x-19276809bc643b47ad144bb65d97f772.webp";